import { c as _c } from "react/compiler-runtime";
import { Divider, Shimmer } from '@onefootprint/ui';
const Loading = () => {
  const $ = _c(4);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="mb-4"><Breadcrumb /></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="mb-4"><Header /></div>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="mb-4"><Divider /></div>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <section data-testid="entity-loading">{t0}{t1}{t2}<div className="mb-9"><Vault /></div></section>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  return t3;
};
const Breadcrumb = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="flex flex-wrap gap-2"><Shimmer height="20px" width="36px" /><Shimmer height="20px" width="4px" /><Shimmer height="20px" width="45px" /></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
const Header = () => {
  const $ = _c(2);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="flex flex-wrap gap-2"><Shimmer height="28px" width="100%" className="max-w-[310px]" /><Shimmer height="24px" width="7px" /><Shimmer height="24px" width="48px" /><Shimmer height="24px" width="150px" /></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="flex flex-col gap-3 md:flex-row md:justify-between">{t0}<div className="flex justify-end gap-2"><Shimmer height="28px" width="104px" /><Shimmer height="28px" width="103px" /><Shimmer height="28px" width="28px" /></div></div>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};
const Vault = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="grid grid-cols-1 md:grid-cols-2 gap-4"><div><Shimmer height="317px" className="w-full min-w-0" /></div><div><Shimmer height="317px" className="w-full min-w-0" /></div><div><Shimmer height="235px" className="w-full min-w-0" /></div><div><Shimmer height="235px" className="w-full min-w-0" /></div></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
export default Loading;